import React from "react";
import { useReactToPrint } from "react-to-print";

import * as Button from "~/Button";
import * as Document from "~/Document";
import { PrintableDocument } from "./PrintableDocument";

export function PrintButton({
  document,
}: {
  readonly document: Document.Document;
}) {
  const [isPrinting, setIsPrinting] = React.useState(false);
  const ref = React.useRef(null);

  const print = useReactToPrint({
    content: () => ref.current,
    onBeforeGetContent: () => setIsPrinting(true),
    onAfterPrint: () => setIsPrinting(false),
    pageStyle: "background: white !important;",
  });

  return (
    <>
      <Button.Component
        primary
        action
        title="Print"
        icon="$icon_printer_line"
        disabled={isPrinting}
        onClick={print}
      />
      <div style={{ display: "none" }}>
        <div ref={ref}>
          <PrintableDocument document={document} />
        </div>
      </div>
    </>
  );
}
